import * as React from 'react';
import { Dialog, Paragraph, Stack } from 'bumbag';
import * as Loads from 'react-loads-next';
type Props = {
  modal: Record<string, any>;
  onClickSubmit: (...args: Array<any>) => any;
  onClickCancel: (...args: Array<any>) => any;
};
export default function RemovePaymentMethodModal({ modal, onClickSubmit, onClickCancel, ...props }: Props) {
  const submitLoader = Loads.useDeferredLoads(onClickSubmit);
  return (
    // @ts-expect-error TS(2741): Property 'baseId' is missing in type '{ children: ... Remove this comment to see the full error message
    <Dialog.Modal
      {...modal}
      hasScroll
      hideOnClickOutside={false}
      hideOnEsc={false}
      showActionButtons
      actionButtonsProps={{
        palette: 'danger',
        submitText: 'Yes, remove card',
        onClickCancel,
        onClickSubmit: submitLoader.load,
        isLoading: submitLoader.isPending,
      }}
      title="Remove saved card?"
    >
      <Stack spacing="major-3">
        <Paragraph>Are you sure you want to remove your saved card? This action cannot be undone.</Paragraph>
      </Stack>
    </Dialog.Modal>
  );
}
